/**
 * Equipment Tracker - Configuration
 * @author Omid Zaeri (zaerio)
 */

const config = {
  // Same-origin: API is proxied through CloudFront at /api/*
  apiUrl: process.env.REACT_APP_API_URL || '/api',
  aupUrl: 'https://policy.a2z.com/docs/4741/publication',
};

export default config;
